import React from 'react';
import { History, GitCommit } from 'lucide-react';
import { PageHead, Card, Fade } from './os2ui';
import { useT } from '../../i18n';
import { CHANGELOG, OS_VERSION, OS_BUILD_DATE } from '../../version';

export default function ChangelogPage() {
  const { lang } = useT();
  const isEs = lang === 'es';
  return (
    <div data-testid="os2-changelog">
      <PageHead
        title={isEs ? 'Historial de versiones' : 'Version history'}
        question={isEs ? '¿Qué hemos mejorado en el sistema y cuándo?' : 'What have we improved in the system, and when?'}
        module="Technical"
      />
      <Fade>
        <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-gray-900 text-white px-4 py-1.5 text-[12px] font-bold" data-testid="changelog-current">
          <GitCommit className="w-3.5 h-3.5 text-[#F77F11]" />
          {isEs ? 'Versión en ejecución' : 'Running version'}: {OS_VERSION} · {OS_BUILD_DATE}
        </div>
      </Fade>
      <div className="relative pl-5 space-y-4 before:absolute before:left-[7px] before:top-2 before:bottom-2 before:w-px before:bg-gray-200">
        {CHANGELOG.map((v, i) => (
          <Fade key={v.version} delay={i * 0.05}>
            <div className="relative" data-testid={`changelog-${v.version}`}>
              <span className={`absolute -left-5 top-4 w-3.5 h-3.5 rounded-full border-2 border-white shadow ${i === 0 ? 'bg-[#F77F11]' : 'bg-gray-300'}`} />
              <Card className="p-5">
                <div className="flex items-center gap-3 flex-wrap">
                  <span className={`rounded-lg px-2.5 py-1 text-[12px] font-black tabular-nums ${i === 0 ? 'bg-orange-50 text-[#d8651a]' : 'bg-gray-100 text-gray-600'}`}>{v.version}</span>
                  <p className="text-[14px] font-bold text-gray-900">{isEs ? v.title.es : v.title.en}</p>
                  <span className="ml-auto text-[11.5px] text-gray-400 tabular-nums">{v.date}</span>
                </div>
                <ul className="mt-3 space-y-1.5">
                  {v.changes.map((c, ci) => (
                    <li key={ci} className="flex gap-2 text-[12.5px] text-gray-600 leading-relaxed">
                      <History className="w-3.5 h-3.5 mt-0.5 shrink-0 text-gray-300" />
                      {isEs ? c.es : c.en}
                    </li>
                  ))}
                </ul>
              </Card>
            </div>
          </Fade>
        ))}
      </div>
      <p className="mt-5 text-[11px] text-gray-400">
        {isEs ? 'Referencia técnica para control de cambios y rollbacks. Cada versión corresponde a un despliegue en producción.' : 'Technical reference for change control and rollbacks. Each version maps to a production deployment.'}
      </p>
    </div>
  );
}
